export default () => {

    let sliders = document.querySelectorAll(".work-slider-custom");
    const mediaMobile = window.matchMedia("(max-width: 1199px)");

    if (!sliders.length) {
        return;
    }

    if (mediaMobile.matches && sliders.length) {

        // Make all slides in sliders active on mobile
        sliders.forEach(node => {

            let swiperId = "#" + node.id;
            let slides = document.querySelectorAll(`${swiperId} .work-slider-custom--slide`);

            if (slides.length) {
                mobileSlides(slides);
            }

        });

        return;

    }


    /* Global timers */
    let timer;
    let resizeTimer;


    /* Window resize event */
    window.addEventListener('resize', () => {

        clearTimeout(resizeTimer);
        clearInterval(timer);

        resizeTimer = setTimeout(() => {
            const newWindowWidth = window.innerWidth;
            if (newWindowWidth <= 1200) {
                sliders.forEach(node => {

                    let swiperId = "#" + node.id;
                    let slides = document.querySelectorAll(`${swiperId} .work-slider-custom--slide`);

                    if (slides.length) {
                        mobileSlides(slides);
                    }

                });
            } else {
                sliders.forEach(node => {

                    let swiperId = "#" + node.id;
                    let slides = document.querySelectorAll(`${swiperId} .work-slider-custom--slide`);
                    let slideDuration = node.dataset.slideDuration;

                    if (slides.length) {
                        resetProgressBars(slides);
                        activateSlide(slides, 0, slideDuration);
                    }

                });
            }
        }, 200);

    });
    /* END - Window resize event */


    sliders.forEach(node => {

        let swiperId = "#" + node.id;
        let slides = document.querySelectorAll(`${swiperId} .work-slider-custom--slide`);
        let slideDuration = node.dataset.slideDuration;

        if (slides.length) {

            slides.forEach((slide, index) => {

                /* Progress bar timer on active slide */
                if (slide.classList.contains('active')) {
                    progressBarPlay(slides, slide, index, slideDuration);
                }

                /* Slide click event */
                slide.addEventListener('click', (event) => {

                    if (!slide.classList.contains('active')) {

                        // Switch to slide
                        resetSlides(slides);
                        slide.classList.add('active');

                    }

                });
                /* END - Slide click event */

            });

        }

    });


    function resetSlides(slides) {
        slides.forEach((slide) => {
            slide.classList.remove('active');
        });
    }

    function mobileSlides(slides) {
        slides.forEach((slide) => {
            if (!slide.classList.contains('active')) {
                slide.classList.add('active');
            }
        });
    }

    function activateSlide(slides, index, duration) {
        slides.forEach((slide) => {
            slide.classList.remove('active');
        });
        slides[index].classList.add('active');
        progressBarPlay(slides, slides[index], index, duration);
    }

    function progressBarPlay(slides, slide, index, duration) {

        let progressBar = slide.children[2];
        let progressBarFill = progressBar.children[0];

        const totalTime = duration ?? 5000; // Defaults to 5 seconds
        const updateInterval = 20; // Update every 20 milliseconds
        const increment = (100 / (totalTime / updateInterval)); // Calculate the increment for each update

        let currentProgress = 0;

        // Set up the interval
        timer = setInterval(() => {

            currentProgress += increment;

            // Ensure progress doesn't exceed 100%
            if (currentProgress >= 100) {

                currentProgress = 100;
                clearInterval(timer); // Stop the timer

                // Activate the next slide
                if (index == 2) {
                    resetProgressBars(slides);
                    activateSlide(slides, 0, duration);
                } else {
                    activateSlide(slides, index + 1, duration);
                }

            }

            // Update the width of the progress bar fill
            progressBarFill.style.width = currentProgress + '%';

        }, updateInterval);

        slides.forEach((elem) => {
            elem.addEventListener('click', (event) => {
                if (!elem.classList.contains('active')) {
                    stopTimer(timer);
                    resetProgressBars(slides);
                }
            });
        });

    }

    function stopTimer(timer) {
        clearInterval(timer);
    }

    function resetProgressBars(slides) {
        const buffer = setInterval(() => {

            slides.forEach((slide) => {
                const progressBar = slide.children[2];
                const progressBarFill = progressBar.children[0];
                progressBarFill.style.width = '0%';
            });
            clearInterval(buffer);

        }, 500);
    }

}